import { call, put, takeLatest, takeEvery } from 'redux-saga/effects';
import { Uchain } from '../redux/api/agent';
import { sagaActions } from './sagaActions';
import {
    updateTTPaymentLogList,
    updateTTPaymentLogOperationObj,
    updateTTPaymentLogIsLoading,
    updateTTPaymentLogTotalElements,
    updateTTPaymentLogDetailList,
    updateTTPaymentLogDetailOperationObj,
    updateTTPaymentLogDetailIsLoading,
} from '../redux/reducers/reducerSlices/TTPaymentLogReducer';

// ── Main list saga ────────────────────────────────────────────────────────────
function* fetchTTPaymentLogSaga(data) {
    const tempStatusObj = { ...data.operationObj };
    try {
        yield put(updateTTPaymentLogIsLoading(true));
        const response = yield call(Uchain.getTTPaymentTransactionLogs, data.payload);
        const list = Array.isArray(response) ? response : (response?.data ?? []);
        const total =
            response?.pagination?.totalCount !== undefined
                ? response.pagination.totalCount
                : list[0]?.TotalCount !== undefined
                ? list[0].TotalCount
                : response?.totalElements !== undefined
                ? response.totalElements
                : list.length;
        yield put(updateTTPaymentLogList(list));
        yield put(updateTTPaymentLogTotalElements(total));
        tempStatusObj.status = true;
        yield put(updateTTPaymentLogOperationObj(tempStatusObj));
    } catch (err) {
        tempStatusObj.status = false;
        tempStatusObj.message = err?.response?.data || 'Unable to fetch payment transaction logs';
        yield put(updateTTPaymentLogOperationObj(tempStatusObj));
    } finally {
        yield put(updateTTPaymentLogIsLoading(false));
    }
}

function* resetTTPaymentLogOperationObjSaga() {
    try {
        yield put(updateTTPaymentLogOperationObj({ type: '', status: '' }));
    } catch {}
}

// ── Detail (by control number) saga ──────────────────────────────────────────
function* fetchTTPaymentLogByControlNumberSaga(data) {
    const tempStatusObj = { ...data.operationObj };
    try {
        yield put(updateTTPaymentLogDetailIsLoading(true));
        const response = yield call(Uchain.getTTPaymentTransactionLogsByControlNumber, data.payload);
        const list = Array.isArray(response) ? response : (response?.data ?? []);
        yield put(updateTTPaymentLogDetailList(list));
        tempStatusObj.status = true;
        yield put(updateTTPaymentLogDetailOperationObj(tempStatusObj));
    } catch (err) {
        tempStatusObj.status = false;
        tempStatusObj.message = err?.response?.data || 'Unable to fetch payment logs by control number';
        yield put(updateTTPaymentLogDetailOperationObj(tempStatusObj));
    } finally {
        yield put(updateTTPaymentLogDetailIsLoading(false));
    }
}

function* resetTTPaymentLogDetailOperationObjSaga() {
    try {
        yield put(updateTTPaymentLogDetailOperationObj({ type: '', status: '' }));
    } catch {}
}

// ── Watchers ──────────────────────────────────────────────────────────────────
export function* fetchTTPaymentLogWatcher() {
    yield takeLatest(sagaActions.FETCH_TT_PAYMENT_LOG, fetchTTPaymentLogSaga);
}

export function* resetTTPaymentLogOperationObjWatcher() {
    yield takeEvery(sagaActions.RESET_TT_PAYMENT_LOG_OPERATION_OBJ, resetTTPaymentLogOperationObjSaga);
}

export function* fetchTTPaymentLogByControlNumberWatcher() {
    yield takeLatest(sagaActions.FETCH_TT_PAYMENT_LOG_BY_CONTROL_NUMBER, fetchTTPaymentLogByControlNumberSaga);
}

export function* resetTTPaymentLogDetailOperationObjWatcher() {
    yield takeEvery(sagaActions.RESET_TT_PAYMENT_LOG_DETAIL_OPERATION_OBJ, resetTTPaymentLogDetailOperationObjSaga);
}